import { get } from './index'

// 获取所有工作室
export const getStudios = () => get('/studio/listStudio')

// 获取工作室详情
export const getStudioById = (id) => get(`/studio/getStudioById?studioId=${id}`)

// 获取工作室活动
export const getStudioActivities = (studioId, params = {}) => 
  get(`/studios/${studioId}/activities`, params)

// 获取工作室团队
export const getStudioTeam = (studioId) => get(`/studios/${studioId}/team`) 